module.exports = __webpack_public_path__ + "img/33.c1a4769d.jpg";